// extracted by mini-css-extract-plugin
export default {"head":"Header_head__DWy7q","pos":"Header_pos__jx79k","around":"Header_around__SO5Td","logo":"Header_logo__9YFPc"};